import { render, staticRenderFns } from "./AdminDatabase.vue?vue&type=template&id=fd95264c&"
import script from "./AdminDatabase.vue?vue&type=script&lang=js&"
export * from "./AdminDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports